import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListAdmin = (params) => {
    return axios.get(`${backendHost}/api/admin/admin/list`, {params});
};

export {
    getListAdmin
}